'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSearchStrong = function IoIosSearchStrong(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.9 23.3l-0.3 0.5 8.4 8.5-2.7 2.7-8.4-8.5-0.5 0.4c-1.9 1.1-4.2 1.9-6.5 1.9-6.6 0-11.9-5.4-11.9-11.9s5.3-11.9 11.9-11.9 11.9 5.3 11.9 11.9c0 2.3-0.8 4.5-1.9 6.4z m-3.4-13.1c-1.8-1.8-4.1-2.7-6.6-2.7s-4.9 0.9-6.7 2.7-2.7 4.2-2.7 6.7 0.9 4.8 2.7 6.6 4.2 2.8 6.7 2.8 4.8-1 6.6-2.8 2.8-4.1 2.8-6.6-1-4.9-2.8-6.7z' })
        )
    );
};

exports.default = IoIosSearchStrong;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-search-strong.js
// module id = 2305
// module chunks = 0